<template>
    <ui-modal :title="`${form.title}`" :name="name" icon="fal fa-hourglass-start" size="xxs" :above-all="true" :load="setLoad">
        <section class="modal-content-line">
            <form>
                <ui-select
                    v-model="form.data.expire_time"
                    :clearable="false"
                    label="Define o tempo de expiração"
                    class="sm mb-15">
                    <option
                        v-for="(option, index) in timeOptions"
                        :key="index"
                        :value="option.value"
                        :selected="option.value === form.data.expire_time">
                        {{ option.label }}
                    </option>
                </ui-select>
            </form>

            <div class="action-nugget">
                <ui-nugget-actions-sage-status v-model="action" action-type="aprove_reserve"  nugget-id="renew-modal" />
            </div>
        </section>

        <template #footer>
            <ui-button :disabled="!canSubmit" type="button" design="md success" @click="submit">Confirmar</ui-button>
        </template>
    </ui-modal>
</template>

<script>
    import { uiModal } from '@/components/ui/modal'
    import { uiSelect } from '@/components/ui/form'
    import { uiButton } from '@/components/ui/buttons'
    import { uiNuggetActionsSageStatus } from '@/components/ui-facilita/nuggets'

    import { reserve } from '@/services/axios'

    import { helpersMixin } from '@/mixins'

    import { mapGetters } from 'vuex'

    const defaultForm = () => ({
        title: 'Renovar Tempo da Reserva',
        data: {
            id: null,
            expire_time: null,
            status: 'reserved'
        }
    })

    const defaultTime = () => ([
        { label: '24:00:00', value: '24:00:00' }
    ])

    export default {
        name: 'renew-time-modal',

        components: {
            uiModal,
            uiSelect,
            uiNuggetActionsSageStatus,
            uiButton,
        },

        mixins: [helpersMixin],

        props: {
            name: {
                type: String,
                require: true,
                default: ''
            }
        },

        data() {
            return {
                form: { ...defaultForm() },
                timeOptions: [],
                action: {},
                eventSuccess: '',
                setLoad: true
            }
        },

        computed: {
            ...mapGetters('auth', {
                user: 'getUser'
            }),

            /**
             * Computed property que define se o formulário poder ser salvo
             */
			canSubmit() {
				if(this.form.data.id &&
					this.form.data.expire_time &&
					this.action &&
					// eslint-disable-next-line no-prototype-builtins
					this.action.hasOwnProperty('no_action') &&
					this.action.no_action)
                    {
                        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                        this.setLoad = false
                        return true
                    }
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.setLoad = false
				return this.action.action_id
			},
          
        },

        mounted() {
            this.$root.$on('modal-open-' + this.name, (params) => {
                this.reset()
                this.$root.$emit('clean--nugget-actions-stage-status-form-renew-modal')
                this.$root.$emit('nugget-actions-stage-status-form-renew-modal')

                /** Verifica se existem configurações para o modal */
                if (params?.config?.title) this.$set(this.form, 'title', params.config.title)

                this.timeOptions = [...defaultTime()]

                if (params?.deal?.id_reserve) {
                    this.$set(this.form.data, 'id', params.deal.id_reserve)
                    this.$set(this.form.data, 'expire_time', params.deal.expire_time)
                    let infos = null
                    if (params.deal.infos) {
                        infos = this.isJSON(params.deal.infos)
                            ? JSON.parse(params.deal.infos)
                            : { ...params.deal.infos }
                    }
                    let times = []

                    /** Verifica se o produto possui tempos de expiração configurados */
                    if (params.deal.units?.availability?.product?.infos?.reserve?.times) {
                        times = Object.values(params.deal.units.availability.product.infos.reserve.times)

                    } else if (infos?.reserve?.times) {
                        times = Object.values(infos.reserve.times)
                    }

                    this.timeOptions = times.map(time => {
                        let label = time.split(':')
                        if (label.length === 2) label.push('00')
                        label = label.join(':')

                        return { label, value: time }
                    })
                }

                this.eventSuccess = params.config.eventSuccess
            })
        },

        beforeDestroy() {
            this.$root.$off('modal-open-' + this.name)
            this.$root.$off('nugget-actions-stage-status-form-renew-modal')
        },

        methods: {
            /**
             * Reseta o estado do formulário para a próxima edição
             */
            reset() {
                this.form = { ...defaultForm() }
                this.timeOptions = []
            },
            /**
             * Submita o formulário de modo a salvar as alterações no negócio
             */
            submit() {
                if (!this.canSubmit) return
                this.setLoad = true
                reserve.updateV2('', this.form.data.id, {...this.form.data, action_id: this.action.action_id})
                    .then(response => {
                        if (response.data.msg) this.$toastr.s(response.data.msg)

                        this.$root.$emit('modal-close-' + this.name)
                        this.$root.$emit(this.eventSuccess)
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    }).finally(() => {
                        this.setLoad = false
                    })
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>